import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import React from 'react';
import CardContent from '@material-ui/core/CardContent';
import CheckIcon from '@material-ui/icons/Check';
import Box from '@material-ui/core/Box';
import CardActions from '@material-ui/core/CardActions';
import cardStyles, { AccountLabel } from './cardStyles';
import AccountName from './AccountName';
import GLBalance from './GLBalance';
import FactaBalance from './FactaBalance';
import TaskReadOnlyDetail from './TaskReadOnlyDetail';

interface Props {
  active: boolean;
  accountName: string;
  loading: boolean;
  glBalance: number;
  closingBalance: number;
  amortizationPostedAmount: number;
}

const ClosedMonthCard = ({
  accountName,
  loading,
  glBalance,
  closingBalance,
  amortizationPostedAmount,
  active,
}: Props) => {
  const classes = cardStyles();
  return (
    <Card
      className={clsx(classes.card, { [classes.active]: active })}
    >
      <CardContent>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <AccountLabel>
            Account
          </AccountLabel>
          <section className={classes.closedTag}>
            <span> CLOSED </span>
            <Box className={clsx(classes.accountStatus, classes.completedTasks)}>
              <CheckIcon className={classes.checkComplete} />
            </Box>
          </section>
        </Box>
        <AccountName accountName={accountName} />
        <GLBalance glBalance={glBalance} loading={loading} />
        <FactaBalance balance={closingBalance} />
      </CardContent>
      <CardActions className={classes.padding15}>
        <TaskReadOnlyDetail
          name="Prepaids Scheduled"
          completed
          amount={0}
        />
        <TaskReadOnlyDetail
          name="Amortization Unposted"
          completed
          amount={0}
        />
        <TaskReadOnlyDetail
          name="Amortization Posted"
          completed
          amount={amortizationPostedAmount}
        />
      </CardActions>
    </Card>
  );
};

export default React.memo(ClosedMonthCard);
